// components/WatchPurchaseGrid.js
import React from 'react';
import styles from './WatchPurchaseGrid.module.scss';
import {useNavigate} from "react-router-dom";

const WatchPurchaseGrid8 = () => {
  const watchBrands = [
    {
      name: "Antikvitete i predmete umetničke vrednosti",
      image: "assets/images/slika.webp",
      models: ["Carski, kraljevski, austrougarski, jugoslovenski i strani"]
    },
    {
      name: "Kolekcionarske predmete",
      image: "assets/images/figurice.png",
      models: ["Statue, figurice, minijature"]
    },
    {
      name: "Predmete od plemenitih metala sa istorijskom vrednošću",
      image: "assets/images/kljuc.webp",
      models: [""]
    },
    {
      name: "Raritete i unikatne predmete koji imaju tržišnu i kolekcionarsku cenu",
      image: "assets/images/zmija.webp",
      models: [""]
    }
  ];

  const navigate = useNavigate();

  const handleClick = (brandName) => {
    const urlName = brandName.toLowerCase().replace(/\s+/g, "-"); // "Audemars Piguet" -> "audemars-piguet"
    window.location.href = `/brands/${urlName}`;
  };

  return (
    <section className={styles.watchPurchaseGrid}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>🏺 Druge starine</h2>

        <div className={styles.grid}>
          {watchBrands.map((brand, index) => (
            <div key={index} className={styles.brandCard}>
              <div className={styles.brandHeader}>
                <h3>OTKUPLJUJEMO</h3>
                <h4>{brand.name}</h4>
                {/*<p>satova</p>*/}
              </div>

              <div className={styles.brandImage}>
                <img src={brand.image} alt={brand.name} />
              </div>

              <div className={styles.models}>
                {brand.models.map((model, idx) => (
                  (
                    idx === brand.models.length - 1 ?
                      <span>{model}</span>
                      :
                      <span>{model}, </span>
                  )
                ))}
              </div>

              <button className={styles.inquiryBtn} onClick={() => handleClick(brand.name)}>Saznaj više</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WatchPurchaseGrid8;